import React, { memo } from 'react';
import { getRessouresUrl, ellipsify, cleanDisplayFilename } from '../../utils/config';
import PdfViewerModal from '../../components/pdf-viewer/PdfViewerModal';

import '@react-pdf-viewer/core/lib/styles/index.css';
import './../../assets/css/style.css';

const TeamCard = (props) => {
    const member = props.data;

    return (
        <div className="custom-card viewer card-shadow" key={member.name+member.title}>
            {/* Profile picture */}
            { member.profilepic 
                ? <div className="image-container">
                    <img  className="image circular"
                            draggable={false}
                            src={getRessouresUrl() + member.profilepic}
                            alt={member.name + " profile picture"} />
                </div>
                : null
            }
            <div className="text-container">
                {/* Name (Title) */}
                <h3>{ member.name } <span style={{ fontFamily: 'BentonSans-Light', fontSize: '2.5vh', fontWeight: "normal" }}>{member.title? ( member.title ) : null}</span></h3>
                {/* Role */}
                {
                    !member.role
                    ? <div>
                        <h5>{ member.role }</h5>
                    </div>
                    : <hr />
                }
                {/* Email address */}
                {
                    member.mail
                        ?   <div>
                                <p>
                                    <a  href={ "mailto:"+member.mail }
                                        draggable={false}>
                                            { member.mail }
                                    </a>
                                </p>
                            </div>
                        : null
                }
                {/* Bio */}
                {
                    member.bio
                        ? <p className="p-reading-text">
                            { member.bio }
                        </p>
                        : null
                }
                {/* Uploaded CVs and documents */}
                {
                    member.cvs.length !== 0
                    ?   <div key={member._id+member.name}>
                            <p className="p-tiny-text pt-4">
                                Curriculum vitæ (CV)
                            </p>
                            {member.cvs.map((cv, index) => (
                                <div key={cleanDisplayFilename(cv)+index}>
                                    <PdfViewerModal btnPrompt={cleanDisplayFilename(cv)}
                                                    modalPrompt={member.name+"'s CV"} 
                                                    ressource={getRessouresUrl()+cv}/>
                                    {index !== (member.cvs.length-1)
                                        ? <span><br /></span>
                                        : null
                                    }
                                </div>
                            ))}
                        </div>
                    : null
                }
                {/* Links and ressources */}
                {
                    member.links.length !== 0
                    ?   <div>
                            <p className="p-tiny-text pt-4">
                                Links and ressources
                            </p>
                            {member.links.map((data, index) => (
                                <span key={data.link+index}> 
                                    <a  target="_blank" 
                                        rel="noreferrer" 
                                        draggable={false}
                                        href={data.link} >
                                            {data.display
                                                ? data.display
                                                : ellipsify(data.link)
                                            }
                                    </a>    
                                    {index !== (member.links.length-1)
                                        ? <span>, </span>
                                        : null
                                    }
                                </span>))}
                        </div>
                    : null
                }
            </div>
        </div>
    );
};

export default memo(TeamCard);
